module.exports = "/static/assets/53feb95d87a0cabdba0602df4b2c7abd.png";